<div class="flex break-before-page flex-col p-6" id="contract">
    <app-header></app-header>

    <div class="flex-grow">
        <h1 class="mb-8 text-center text-lg font-bold underline">
            CONTRACT FOR SERVICE AGREEMENT
        </h1>

        <p class="mb-6">
            THIS AGREEMENT IS MADE ON (DATE)<span class="input-span">{{
                data.currentDate
            }}</span
            >(the “Agreement”).
        </p>

        <div class="mb-6">
            <p class="mb-2"><b>BETWEEN</b></p>
            <ol class="list-bracket-decimal">
                <li>
                    <p>
                        NEXUS MANAGEMENT SERVICES PTE LTD (UEN 201714926N), a
                        company incorporated in SINGAPORE and having its
                        principal office at 2 Venture Drive, #08-02 Vision
                        Exchange Singapore 608526 (the “<b>Company</b>”); and
                    </p>
                </li>
                <li>
                    <p>
                        (NAME & NRIC)<span class="input-span"
                            ><b
                                >{{ data.contractName }} &
                                {{ data.icNumber }}</b
                            ></span
                        >
                        of (ADDRESS)<span class="input-span"
                            ><b>{{ data.address }}</b></span
                        >
                        (the “<b>Contractor</b>”).
                    </p>
                </li>
            </ol>
        </div>

        <div class="mb-6">
            <p class="mb-2"><b>WHEREAS</b></p>
            <ol class="list-inside list-[upper-alpha]">
                <li class="list-item">
                    The Contractor is skilled in providing Promoter and related
                    services
                </li>
                <li class="list-item">
                    The Company wishes to engage the Contractor to provide these
                    services in accordance with the terms and conditions of this
                    Agreement.
                </li>
            </ol>
        </div>

        <div class="mb-6">
            <p class="mb-2"><b>IT IS HEREBY AGREED AS FOLLOWS</b></p>
            <ol class="list-decimal-custom">
                <!-- 1 DEFINITIONS AND INTERPRETATIONS -->
                <li class="mb-4 block">
                    <b>DEFINITIONS AND INTERPRETATIONS</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <div>
                                <p>
                                    Unless the context otherwise requires, the
                                    following words and expressions shall have
                                    the following meanings in this Agreement:
                                </p>
                                <table>
                                    <tr>
                                        <th>"Agreement"</th>
                                        <td>
                                            this Agreement including
                                            <u
                                                >the Schedule and Annex A & B
                                                attached within</u
                                            >;
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>"Confidential Information"</th>
                                        <td>
                                            all information or data of a
                                            confidential or proprietary nature
                                            disclosed to or received by the
                                            Contractor, which is labelled or
                                            designated as confidential, relating
                                            to the products, services, business
                                            or proposed business, finances,
                                            transactions, staff and affairs of
                                            the Company, including Intellectual
                                            Property Rights and trade secrets;
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>"Fee"</th>
                                        <td>
                                            the meaning given to it in
                                            <u>Clause 4</u> and
                                            <u>the Schedule</u> and all sums due
                                            to the Contractor under this
                                            Agreement shall be payable in
                                            Singapore Dollars in Singapore;
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>"Interest Rate"</th>
                                        <td>
                                            interest shall accrue on any late
                                            payment at a rate of
                                            <u>0% per annum</u> calculated on a
                                            daily basis from the due date of the
                                            relevant payment until the date of
                                            payment. The Contractor may include
                                            the interest accrued in its next
                                            invoice, as part of the amount to be
                                            paid by the Company.
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>"Personal Data"</th>
                                        <td>
                                            has the meaning set out in the
                                            Personal Data Protection Act
                                            (“<b>PDPA</b>”);
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>"Services"</th>
                                        <td>
                                            the services defined in
                                            <u>the Schedule</u> to this
                                            Agreement;
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>"Works/Service"</th>
                                        <td>
                                            all materials, hard copy documents,
                                            hardware documents, operating or
                                            training manuals, instructions,
                                            notes and data in whatever form,
                                            prepared or produced by the
                                            Contractor in providing the
                                            Services.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </li>
                    </ol>
                </li>

                <!-- 2 COMMENCEMENT AND DURATION -->
                <li class="mb-4">
                    <div>
                        <b>COMMENCEMENT AND DURATION</b>
                        <p>
                            The Contractor's engagement under this Agreement
                            will commence on the agreed Commencement Date and
                            will continue until the Services have been provided
                            in full or until termination of the Agreement in
                            accordance with <u>Clause 11</u>.
                        </p>
                    </div>
                </li>

                <!-- 3 PROVISION OF SERVICES -->
                <li class="mb-4 block">
                    <b>PROVISION OF SERVICES</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                The Contractor will provide the Services
                                required by the Company with reasonable skill
                                and care and in accordance with this Agreement.
                            </p>
                        </li>
                        <li>
                            <p>
                                The Contractor will notify the Company if he/she
                                is unable to provide the Services. In the event
                                that The Contractor is unable to provide the
                                Services as required by the Company, a
                                replacement of personnel must be arranged and
                                reached by the stipulated timing, at it’s own
                                cost and informed the Company of the outcome.
                            </p>
                        </li>
                        <li>
                            <div>
                                <p>The Contractor will not:</p>
                                <ol class="list-decimal-custom">
                                    <li>
                                        <p>
                                            hold himself/herself out as having
                                            authority to bind the Company; nor
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            have any authority to incur expenses
                                            in the name of or on behalf of the
                                            Company, unless the Contractor has
                                            obtained the prior written consent
                                            of the Company.
                                        </p>
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li>
                            <p>
                                It is agreed that the Contractor is acting as an
                                independent contractor and not as an employee of
                                the Company asserting any rights under the
                                Employment Act.
                            </p>
                        </li>
                        <li>
                            <p>
                                The Contractor will provide personal instruments
                                and/or equipment and/or computer equipment
                                necessary for the provision of the Services and
                                the Contractor will be liable, at his/her own
                                cost, to keep any such personal instruments
                                and/or equipment and/or computer equipment in a
                                safe and proper operating condition.
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 4 FEES -->
                <li class="mb-4">
                    <div>
                        <b>FEES</b>
                        <p>
                            The Company will pay to the Contractor in
                            consideration of the provision of the Services the
                            fee set out in <u>the Schedule</u> within
                            <u>7 days of receipt</u> of an invoice submitted by
                            the Contractor, provided the Contractor is present
                            for to provide service on the week of payment, else
                            payment will be made within the next 7 days from the
                            date which the Contractor resume to provide service.
                            Contractor to note that there will be a deduction of
                            $0.50 for bank charges in the weekly payment basis.
                        </p>
                    </div>
                </li>

                <!-- 5 LIMITATION OF LIABILITY -->
                <li class="mb-4 block">
                    <b>LIMITATION OF LIABILITY</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                Without prejudice to <u>Clause 5.2</u>, the
                                maximum aggregate liability under this
                                Agreement, whether in contract, tort (including
                                negligence) or otherwise, shall not exceed the
                                Fee and neither party shall be liable to the
                                other for any indirect or consequential loss.
                            </p>
                        </li>
                        <li>
                            <p>
                                Nothing in this Agreement shall exclude or in
                                any way limit either party’s liability for
                                fraud, death or personal injury caused by its
                                negligence or any other liability to the extent
                                such liability may not be excluded or limited as
                                a matter of law.
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 6 INDEMNITY -->
                <li class="mb-4">
                    <div>
                        <b>INDEMNITY</b>
                        <p>
                            The Contractor agrees to indemnify and hold the
                            Company harmless from and against any loss or
                            liability arising out of his/her performance of the
                            Services under this Agreement.
                        </p>
                    </div>
                </li>

                <!-- 7 STATUS AND TAX LIABLITY -->
                <li class="mb-4">
                    <div>
                        <b>STATUS AND TAX LIABLITY</b>
                        <p>
                            The Contractor shall have the status of a
                            self-employed person and shall not be entitled to
                            any pension, bonus or other fringe benefits from the
                            Company and it is agreed that the Contractor shall
                            be responsible for all income tax liabilities and
                            contributions to the Central Provident Fund or
                            similar contributions in respect of the Fees.
                        </p>
                    </div>
                </li>

                <!-- 8 CONFLICT OF INTEREST -->
                <li class="mb-4 block">
                    <b>CONFLICT OF INTEREST</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                The Contractor warrants that to the best of his
                                knowledge no conflict of interest exists or is
                                likely to arise in the performance of his
                                obligations under this Agreement.
                            </p>
                        </li>
                        <li>
                            <p>
                                The Contractor shall not, during the course of
                                this Agreement, engage in any activity likely to
                                compromise the ability of the Contractor to
                                perform his obligations under this Agreement
                                fairly and independently. The Contractor shall
                                immediately disclose to the Company any activity
                                which constitutes or may constitute a conflict
                                of interest.
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 9 CONFIDENTIAL INFORMATION -->
                <li class="mb-4 block">
                    <b>CONFIDENTIAL INFORMATION</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                The Contractor will not during the period of
                                this Agreement, without the prior written
                                approval of the Company, use for her/her own
                                benefit or for the benefit of any other person,
                                firm, company or organisation or directly or
                                indirectly divulge or disclose to any person any
                                Confidential Information which has come, or may
                                come, to the Contractor's knowledge during or in
                                connection with the engagement.
                            </p>
                        </li>
                        <li>
                            <div>
                                <p>
                                    The restrictions contained in this Clause
                                    will not apply to:
                                </p>
                                <ol class="list-decimal-custom">
                                    <li>
                                        <p>
                                            any Confidential Information which
                                            is already available to, or within
                                            the knowledge of, the public
                                            generally; or
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            any use or disclosure authorised by
                                            the Company or required by law.
                                        </p>
                                    </li>
                                </ol>
                            </div>
                        </li>
                    </ol>
                </li>

                <!-- 10 DATA PROTECTION -->
                <li class="mb-4">
                    <div>
                        <b>DATA PROTECTION</b>
                        <div>
                            <p class="mb-2">
                                The Contractor will comply in all material
                                respects with his/her obligations under the PDPA
                                in relation to the management or protection of
                                Personal Data which the Contractor processes (if
                                any) in the provision of the Services under this
                                Agreement.
                            </p>
                            <p>
                                <u
                                    >The contractor agreed and consent to allow
                                    the Company and its employees, agents,
                                    affiliates and third party service providers
                                    to collect, use, disclose and/or process
                                    personal data; use of photographs and
                                    recordings related to work or company event,
                                    if any, for publicity purposes and release
                                    the Company from any liabilities that may
                                    arises, if any.</u
                                >
                            </p>
                        </div>
                    </div>
                </li>

                <!-- 11 TERMINATION -->
                <li class="mb-4 block">
                    <b>TERMINATION</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                Either party may terminate this Agreement by
                                giving to the other not less than 14 days’
                                notice in writing to the other party.
                            </p>
                        </li>
                        <li>
                            <div>
                                <p>
                                    The Company may, by written notice to the
                                    Contractor and at any time, terminate this
                                    Agreement with immediate effect with no
                                    further obligation to make any pre-existing
                                    or further payment to the Contractor if:
                                </p>
                                <ol class="list-decimal-custom">
                                    <li>
                                        <p>
                                            the Contractor commits any serious
                                            or repeated breach or non-observance
                                            of any of the terms or conditions of
                                            this Agreement (including any
                                            non-compliance to Annex A of this
                                            service agreement) ; or
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            the Contractor is guilty of any act
                                            of fraud or dishonesty in relation
                                            to the Company or acts in any manner
                                            which brings the Company into
                                            disrepute; or
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            a bankruptcy order is made against
                                            the Contractor such that, in the
                                            reasonable opinion of the Company,
                                            the Contractor is no longer able to
                                            provide the Services; or
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            the Contractor is convicted of any
                                            criminal offence which materially
                                            affects the Contractor’s ability to
                                            perform the Services.
                                        </p>
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li>
                            <div>
                                <p>
                                    The Contractor may, by written notice to the
                                    Company and at any time, terminate this
                                    Agreement with immediate effect without
                                    liability to pay any compensation or damages
                                    if:
                                </p>
                                <ol class="list-decimal-custom">
                                    <li>
                                        <p>
                                            the Company commits any serious or
                                            repeated breach or non-observance of
                                            any of the terms or conditions of
                                            this Agreement, and for the
                                            avoidance of doubt, a failure to pay
                                            the Fee on the due date will be
                                            treated as a serious breach; or
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            the Company or any of its directors,
                                            officers, employees or agents
                                            commits an act of fraud or
                                            dishonesty, or acts in any manner
                                            which in the reasonable opinion of
                                            the Contractor brings, or is likely
                                            to bring, the Contractor into
                                            disrepute; or
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            the Company makes a resolution for
                                            its winding up, makes an arrangement
                                            or composition with its creditors or
                                            makes an application to a court of
                                            competent jurisdiction for
                                            protection from its creditors or an
                                            administration or winding up order
                                            is made or an administrator or
                                            receiver is appointed in relation to
                                            the Company.
                                        </p>
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li>
                            <p>
                                Neither party will be in breach of this
                                Agreement if there is any total or partial
                                failure of performance due to any act of God,
                                fire, act of government or state, war, civil
                                commotion, labour disputes of whatever nature
                                and any other reason beyond the control of
                                either party (each a
                                <b>Force Majeure Event</b>).
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 12 OBLIGATIONS UPON TERMINATION -->
                <li class="mb-4">
                    <div>
                        <b>OBLIGATIONS UPON TERMINATION</b>
                        <p>
                            The Contractor will as soon as reasonably
                            practicable upon the termination of this Agreement,
                            surrender and any other property of the Company that
                            have been received by the Contractor.
                        </p>
                    </div>
                </li>

                <!-- 13 NOTICES -->
                <li class="mb-4 block">
                    <b>NOTICES</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                Notices under this Agreement shall be in writing
                                and sent to the recipient's registered office or
                                address as set out on the first page of this
                                Agreement (or email address set out below).
                                Notices may be given and shall be deemed
                                received by email to Contractor’s and Company’s
                                email addresses: on receipt of a delivery.
                            </p>
                        </li>
                        <li>
                            <p>
                                This clause does not apply to notices given in
                                legal proceedings or arbitration.
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 14 ENTIRE AGREEMENT -->
                <li class="mb-4 block">
                    <b>ENTIRE AGREEMENT</b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                The parties agree that this Agreement
                                constitutes the entire agreement between them
                                relating to the engagement and supersedes all
                                previous agreements, understandings and
                                arrangements between them, whether in writing or
                                oral in respect of its subject matter.
                            </p>
                        </li>
                        <li>
                            <p>
                                Each party acknowledges that it has not entered
                                into this Agreement in reliance on, and shall
                                have no remedies in respect of, any
                                representation or warranty that is not expressly
                                set out in this Agreement. No party shall have
                                any claim for innocent or negligent
                                misrepresentation on the basis of any statement
                                in this Agreement.
                            </p>
                        </li>
                        <li>
                            <p>
                                Nothing in this Agreement purports to limit or
                                exclude any liability for fraud.
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 15 VARIATION -->
                <li class="mb-4">
                    <div>
                        <b>VARIATION</b>
                        <p>
                            No variation of this Agreement shall be valid or
                            effective unless it is in writing, refers to this
                            Agreement and is duly signed or executed by, or on
                            behalf of, each party.
                        </p>
                    </div>
                </li>

                <!-- 16 ASSIGNMENT -->
                <li class="mb-4">
                    <div>
                        <b>ASSIGNMENT</b>
                        <p>
                            Neither party may without the consent of the other
                            party assign, transfer, subcontract, license or
                            otherwise dispose of any right, obligation or
                            benefit conferred or granted under this Agreement to
                            any third party.
                        </p>
                    </div>
                </li>

                <!-- 17 REMEDIES AND WAIVER  -->
                <li class="mb-4 block">
                    <b>REMEDIES AND WAIVER </b>
                    <ol class="list-decimal-custom">
                        <li>
                            <p>
                                Any remedy or right conferred upon the
                                Contractor for breach of this Agreement will be
                                in addition to and without prejudice to all
                                other rights and remedies available to it by
                                law.
                            </p>
                        </li>
                        <li>
                            <p>
                                Any waiver of any breach of this Agreement shall
                                not be deemed to apply to any succeeding breach
                                of the provision or of any other provision of
                                this Agreement. No failure to exercise and no
                                delay in exercising on the part of any of the
                                Parties any right, power or privilege hereunder
                                shall operate as a waiver thereof nor shall any
                                single or partial exercise of any right, power
                                or privilege preclude any other or further
                                exercise thereof or the exercise of any other
                                right, power or privilege.
                            </p>
                        </li>
                    </ol>
                </li>

                <!-- 18 GOVERNING LAW AND JURISDICTION -->
                <li class="mb-4">
                    <div>
                        <b>GOVERNING LAW AND JURISDICTION</b>
                        <p>
                            The Agreement shall be governed by and construed in
                            accordance with the laws of Singapore.
                        </p>
                    </div>
                </li>
            </ol>
        </div>
    </div>

    <app-footer
        [signature]="data.signature"
        [endCode]="data.endCode"
    ></app-footer>
</div>

<div class="flex break-before-page flex-col p-6" id="contract-1">
    <app-header></app-header>

    <div class="flex-grow">
        <p class="mb-6">
            <b>IN WITNESS WHEREOF</b> this Agreement has been entered into the
            day and year first above written.
        </p>

        <table class="mb-6">
            <tr>
                <td colspan="3">Signed by</td>
            </tr>
            <tr>
                <td width="388px">
                    for and on behalf of NEXUS MANAGEMENT SERVICES PTE LTD
                </td>
                <td class="px-4">)</td>
                <td id="sign_nexus" rowspan="4"></td>
            </tr>
            <tr>
                <td></td>
                <td class="px-4">)</td>
                <td></td>
            </tr>
            <tr>
                <td>in the presence of</td>
                <td class="px-4">)</td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td class="px-4">)</td>
                <td></td>
            </tr>
        </table>

        <table class="mb-8">
            <tr>
                <td width="388px">Signed by ({{ data.contractName }})</td>
                <td class="px-4">)</td>
                <td id="sign_contractor" rowspan="4">
                    @if (data.signature) {
                        <img
                            [src]="data.signature"
                            alt="Signature"
                            class="signature-image"
                        />
                    }
                </td>
            </tr>
            <tr>
                <td></td>
                <td class="px-4">)</td>
                <td></td>
            </tr>
        </table>

        <p>
            Should you have any queries, please do not hesitate to contact HR
            team at:<br />
            Office Tel: +65 69147715 (Monday to Friday: 9am to 5pm, closed on
            Public Holidays)<br />
            E-mail: hr&#64;nexus-ms.com.sg<br />
            Thank you.
        </p>
    </div>

    <app-footer
        [signature]="data.signature"
        [endCode]="data.endCode"
    ></app-footer>
</div>

<!-- THE SCHEDULE -->
<div class="flex break-before-page flex-col p-6" id="contract-2">
    <app-header></app-header>

    <div class="flex-grow">
        <h1 class="text-center text-lg font-bold">THE SCHEDULE</h1>
        <hr />

        <p class="mb-6">
            This Schedule describes the services to be performed by the
            Contractor on the terms and conditions of this Agreement (the
            Services), Annex A (Confirmation to provide service as Contractor)
            and Annex B (Do and Don’t); the fee payable by the Company in
            respect of those Services (the Fee); and the basis on which the
            Contractor is to invoice the Company in respect of the Fee.
        </p>

        <p class="mb-6">
            <b>Services</b><br />
            <u>Promoter services</u> and other general duties as discussed,
            informed and agreed.
        </p>

        <p class="mb-6">
            <b>Time</b><br />
            As per project schedule commencing
            <span class="input-span">{{
                data.startDate || data.currentDate
            }}</span>
            (DD/MM/YY)
            for a period ending {{ data.endDateText || '30 June 2025' }}.
        </p>

        <p class="mb-6">
            <b>Fee</b><br />
            As per informed and agreed.
        </p>

        <p>
            <b>Invoicing</b><br />
            7 days upon receipt of proof of service. Contractor to note that
            there will be a deduction of $0.50 for bank charges in the weekly
            payment basis.
        </p>

        <hr />
    </div>

    <app-footer
        [signature]="data.signature"
        [endCode]="data.endCode"
    ></app-footer>
</div>

<!-- Annex A – Confirmation To Provide Service As Contractor -->
<div class="flex break-before-page flex-col p-6" id="annex-a">
    <app-header></app-header>

    <div class="flex-grow">
        <h1 class="text-center text-lg font-bold">
            Annex A – Confirmation To Provide Service As Contractor
        </h1>

        <hr />

        <p class="mb-6">
            I have been briefed and acknowledged to provide the mentioned
            service requirements as Contractor:
        </p>

        <p class="mb-2">
            As Contractor, I understand that I am not entitled to the following
            employee benefits:
        </p>
        <p>1. CPF & workfare supplement</p>
        <p>2. Work Injury Insurance</p>
        <p>3. Sick & Hospital Leave</p>
        <p>
            4. Maternity / paternity / shared parental leave / childcare /
            infant care / adoption leave / unpaid infant care leave
        </p>
        <p>5. Medical Consultation Claim (with sick leave)</p>

        <p class="mb-2 mt-6">
            I confirmed that I have been briefed on the following:
        </p>
        <p>1. Safety Operations at Workplace Area</p>
        <p>2. Safety Advice on walkway that Workplace Operate</p>
        <p>
            3. Safety Advice on the use of appropriate exit after providing
            service
        </p>
        <p>4. MOM sharing on the reported fatality workplace incidents</p>
        <p>5. Nexus safety awareness identification and escalation process</p>

        <p class="mt-6">
            I am aware that the Company may inform me on the conversion of this
            Contract for Service Agreement to a Contract of Service Agreement
            (Full Time/ Part Time ) pending my commitment and performance.
        </p>
    </div>

    <app-footer
        [signature]="data.signature"
        [endCode]="data.endCode"
    ></app-footer>
</div>

<!-- Annex B -->
<div class="flex break-before-page flex-col p-6" id="annex-b">
    <app-header></app-header>

    <div class="flex-grow">
        <h1 class="text-center text-lg font-bold">Annex B</h1>

        <hr />

        <p class="mb-6">
            Annex B describes the Do and Don’t of the services to be performed
            by the Contractor on the terms and conditions of this Agreement (the
            Services) and The Schedule; the fee payable by the Company in
            respect of those Services (the Fee);
        </p>

        <p class="mb-2">Do's</p>
        <p>
            1. The Contractor is to be familiar with the location and the
            required transport needed to reach.
        </p>
        <p>
            2. The Contractor is compulsory to attain the Basic Food Safety &
            Hygiene course certification at the Contractor's cost and expense.
        </p>
        <p>
            3. The Contractor is to reach the work site 15 minutes before the
            official start time to prepare the necessary prior to commencement
            of production.
        </p>
        <p>
            4. The Contractor is to be aware and conform to the safety and food
            hygiene protocol of the work site (all jewellery, watches and
            accessories to be removed and fingernails to be trimmed and free
            from nail polish before entering the food production area.
        </p>
        <p>
            5. The Contractor is to be aware that he/she is required to inform
            the Company if he/she is not feeling well. In such circumstance, the
            Contractor is to seek for medical consultation and to obtain Medical
            Certificate (MC). Failure to do so is regarded as Absence Without
            Official Leave (AWOL) and the Company has the rights to remove the
            Contractor's service immediately and without any pre-existing or
            future payment.
        </p>
        <p>
            6. The Contractor is to be aware that he/she is required to inform
            the Company of 2 weeks in advance if he/she is unable to provide the
            mentioned agreed service.
        </p>
        <p>
            7. The Contractor is to be aware that he/she should always consult
            and feedback to the Company should he/she faces any issues at work
            site. The Company will attempt to resolve the issues for the
            Contractor.
        </p>

        <p class="mb-2 mt-6">
            Don't - In the below mentioned circumstances, the Company has the
            rights to remove the Contractor's service immediately and without
            any pre-existing or future payment.
        </p>
        <p>
            1. The Contractor is to be aware that failure to report at the
            workplace at the stated timing without any accepted reasons is
            considered as Absence Without Official Leave (AWOL).
        </p>
        <p>
            2. The Contractor is to be aware that he/she is not to leave the
            work station without valid reason or permission from the Company or
            Client.
        </p>
        <p>
            3. The Contractor is to be aware that he/she should not be found
            missing during work.
        </p>
        <p>
            4. The Contractor is to be aware that he/she should not be rude and
            impolite to Company's employees, Clients and other vendors providing
            service in the location.
        </p>
        <p>
            5. The Contractor is not to be engaged directly or indirectly by the
            Company's Client(s) / Competitors without informing the Company.
        </p>
    </div>

    <app-footer
        [signature]="data.signature"
        [endCode]="data.endCode"
    ></app-footer>
</div>

<div class="dialog-actions">
    <button mat-button (click)="onClose()">Cancel</button>
    <button mat-button color="primary" (click)="onAccept()">
        Accept & Generate
    </button>
    <button mat-button color="primary" (click)="exportToPDF()">
        Export to PDF
    </button>
</div>

<!-- Add loading indicator -->
<div *ngIf="isExporting" class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Generating PDF...</p>
</div>
